// extracted by mini-css-extract-plugin
module.exports = {"color":"style__color__5zT+I","swatch":"style__swatch__HBGCe","popover":"style__popover__GYYRS","cover":"style__cover__IZ0ND"};